import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import StatementView from "@/components/StatementView";
import CustomerPrices from "@/components/CustomerPrices";
import CustomerTasksPanel from "@/components/CustomerTasksPanel";

export default function CustomerDetail() {
  const { id } = useParams();
  const [customer, setCustomer] = useState(null);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    Promise.all([api.get("/customers"), api.get("/company")])
      .then(([cs, c]) => { setCustomer(cs.data.find(x => x.id === id)); setCompany(c.data); });
  }, [id]);

  if (!customer) return <div className="text-sm text-slate-500">Loading…</div>;

  return (
    <div className="space-y-4" data-testid="customer-detail-page">
      <div>
        <div className="text-xs text-slate-500"><Link to="/customers" className="hover:underline">Customers</Link> / {customer.name}</div>
        <h1 className="text-2xl font-bold tracking-tight mt-1" style={{fontFamily:'Plus Jakarta Sans'}}>{customer.name}</h1>
        <div className="text-xs text-slate-500 mt-1 mono">{customer.phone} {customer.gstin && `· GSTIN ${customer.gstin}`}</div>
      </div>
      <CustomerPrices customerId={id} />
      <StatementView customerId={id} company={company} />
      <CustomerTasksPanel customerId={id} />
    </div>
  );
}
